import { styled } from '@mui/system';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import MenuItemNameTypography from 'components/MenuItemNameTypography';
import MenuItemDescriptionTypography from 'components/MenuItemDescriptionTypography';
import {
  getMenuItemNamesLighterColor,
  getMenuItemNamesColor,
  getMenuItemNamesTypography,
  getSectionNavMediumColor,
  getHeaderAndNavigationTypography,
  getButtonFontHoverColor,
  getButtonBackgroundHoverColor
} from 'styles/helpers/getThemeStyles';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import muiPropForwarding from 'styles/helpers/muiPropForwarding';

export const StyledSnackbar = styled(Snackbar)(({ theme }) => {
  const fontStyles = getHeaderAndNavigationTypography(theme);
  return {
    '& .MuiSnackbarContent-root': {
      backgroundColor: '#8B535E',
      justifyContent: 'center',
      ...fontStyles
    }
  };
});

export const StyledGroupOrderWrapper = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.card.background.main,
  margin: '20px 16px'
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  color: getMenuItemNamesColor(theme),
  fontSize: '20px',
  fontWeight: '500'
}));

export const StyledInputName = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: getMenuItemNamesLighterColor(theme)
  },
  '& .MuiOutlinedInput-input': {
    color: getMenuItemNamesColor(theme)
  },
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: '450',
  letterSpacing: '1px',
  fontSize: '14px',
  lineHeight: '24px'
}));

export const JoinDetailTypography = styled(MenuItemNameTypography)(
  ({ theme }) => {
    const fontStyles = getMenuItemNamesTypography(theme);

    return {
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '1px',
      fontStyle: 'normal',
      color: getSectionNavMediumColor(theme),
      ...fontStyles
    };
  }
);

export const StyledGroupOrderButton = styled(PrimaryCta, {
  shouldForwardProp: muiPropForwarding('isMobile')
})(({ isMobile }) => {
  const styles = {
    '&.MuiButton-containedPrimary': {}
  };

  if (isMobile) {
    styles['&.MuiButton-containedPrimary'].position = 'absolute';
    styles['&.MuiButton-containedPrimary'].bottom = '45px';
    styles['&.MuiButton-containedPrimary'].left = '0';
  }
  return styles;
});

export const StyledErrorContainer = styled(Box)(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    height: '72px',
    width: '100%',
    marginBottom: '1rem',
    marginTop: '1rem',
    backgroundColor: getButtonBackgroundHoverColor(theme)
  };
});

export const StyledErrorMessage = styled(MenuItemNameTypography)(
  ({ theme }) => {
    const fontStyles = getMenuItemNamesTypography(theme);
    return {
      display: 'block',
      paddingLeft: '.5rem',
      fontWeight: '500',
      fontSize: '16px',
      lineHeight: '24px',
      letterSpacing: '1px',
      fontStyle: 'normal',
      color: getButtonFontHoverColor(theme),
      ...fontStyles
    };
  }
);

export const StyledErrorHelperMessage = styled(MenuItemDescriptionTypography)(
  ({ theme }) => {
    const fontStyles = getMenuItemNamesTypography(theme);
    return {
      display: 'block',
      paddingLeft: '.5rem',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '1px',
      fontStyle: 'normal',
      color: getButtonFontHoverColor(theme),
      ...fontStyles
    };
  }
);
